import React from 'react'
import { cn } from '@/utils/ui'

const PAGE_NAV_WIDTH = 'w-[224px] 2xl:w-[309px]'
const CONTENT_MAX_HEIGHT = 'calc(100vh - 240px)'

interface ContentGutterProps {
  onPageNav?: React.ReactNode
  sideNav?: React.ReactNode
  children: React.ReactNode
  className?: string
  isNarrow?: boolean
}

export const ContentGutter: React.FC<ContentGutterProps> = ({
  onPageNav,
  sideNav,
  children,
  className,
  isNarrow = true,
}: ContentGutterProps) => {
  return (
    <div className={`flex flex-col lg:flex-row lg:ms-0 gap-5 ${className}`}>
      {sideNav && (
        <aside className={`lg:${PAGE_NAV_WIDTH} w-full lg:hidden block mb-5`}>{sideNav}</aside>
      )}
      {sideNav && (
        <aside className={`${PAGE_NAV_WIDTH} hidden lg:block`}>
          <div
            className={`sticky top-[240px] hidden lg:block scrollbar-hide`}
            style={{ maxHeight: CONTENT_MAX_HEIGHT, overflow: 'auto' }}
          >
            {sideNav}
          </div>
        </aside>
      )}
      <div
        className={cn('w-full h-full mx-auto ms-auto', {
          'lg:min-w-[600px] lg:max-w-[760px]': isNarrow,
          'lg:min-w-[720px] lg:max-w-[895px]': !isNarrow,
        })}
      >
        {children}
      </div>
      <aside className={`${PAGE_NAV_WIDTH} hidden lg:block`}>
        <div
          className={`sticky top-[240px] hidden lg:block scrollbar-hide`}
          style={{ maxHeight: CONTENT_MAX_HEIGHT, overflow: 'auto' }}
        >
          {onPageNav}
        </div>
      </aside>
    </div>
  )
}
